<template>
    <v-layout>
        <v-flex class="my-activity">
            <v-flex tag="h2">{{memberProfileConstants.MY_ACTIVITY}}
                <i class="fas fa-external-link-alt" data-qe-id="my-activity_dialog_open_link" @click="dialog = true"></i>
                <strong data-qe-id="my-activity_un-follow" @click="followingUser(false)" v-if="isProfileFollowing" class="notFollowing active"><i class="fas fa-check"></i>{{memberProfileConstants.FOLLOWING}}</strong>
                <strong data-qe-id="my-activity_follow" @click="followingUser(true)" class="notFollowing" v-if="isAddProfileFollowingVisible">{{memberProfileConstants.FOLLOW_ME}}</strong>
                <!-- TODO: Need to change hardcoded value (1879) when data is ready from API -->
                <!-- need to remove false in v-if -->
                <a v-if="false && !isSectionVisible && isCurrentUser">{{memberProfileConstants.DEFAULT_EDIT_TEXT.MANAGE_FOLLOWERS}}<span>(1897)</span></a>
            </v-flex>
            <v-flex v-if="!isSectionVisible && isCurrentUser"> {{memberProfileConstants.DEFAULT_EDIT_TEXT.MY_ACTIVITY}} </v-flex>
            <v-layout row wrap>
                <v-flex xs6 v-for="(activity,index) in myActivity" :key="index">
                    <v-layout row wrap mb-4>
                        <v-flex xs2>
                            <v-img :src="activity.imgageUrl" height="76px" contain></v-img>
                        </v-flex>
                        <v-flex xs9>
                            <v-flex class="my-activity__title">{{activity.name}}</v-flex>
                            <v-flex class="my-activity__share">{{activity.share}}</v-flex>
                            <v-flex class="my-activity__actions">{{activity.likes}} | {{activity.comments}}</v-flex>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-dialog v-model="dialog" width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{memberProfileConstants.MY_ACTIVITY}}
                </v-card-title>
                <v-card-text>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat data-qe-id="close_dialog_btn" @click="dialog = false">
                        {{appCommonConstants.CLOSE}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import { memberProfileConstants } from "./memberProfile.constants.js";
    import { appCommonConstants } from "../appCommon.constants.js";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    
    export default {
        name: "MyActivity",
        data: () => ({
            memberProfileConstants,
            appCommonConstants,
            dialog: false,
        }),
        props: {
            memberId: {
                type: String,
                required: true,
            },
        },
        created() {
            this.getMyActivity(this.memberId);
            this.getProfileFollowing(this.memberId);
        },
        methods: {
            ...mapActions({
                getMyActivity: `memberProfile/${storeAction.getMyActivity}`,
                getProfileFollowing: `memberProfile/${storeAction.getProfileFollowing}`,
                addProfileFollowing: `memberProfile/${storeAction.addConnection}`,
            }),
            followingUser(follow) {
                let requestBody = [];
                requestBody = this.profileFollowing;
                requestBody.isFollowed = follow;
                this.addProfileFollowing(requestBody)
                    .then(() => {
                        this.getProfileFollowing(this.memberId);
                    });
            },
        },
        computed: {
            ...mapGetters({
                currentUserId: `memberProfile/${storeGetters.currentUserId}`,
                myActivity: `memberProfile/${storeGetters.myActivity}`,
                profileFollowing: `memberProfile/${storeGetters.profileFollowing}`,
                chapterAdminEditable: `memberProfile/${storeGetters.chapterAdmin}`,           
            }),
            isProfileFollowing() {
                return this.profileFollowing.isFollowed && !this.isCurrentUser;
            },
            isAddProfileFollowingVisible() {
                return !this.profileFollowing.isFollowed && !this.isCurrentUser;
            },
            isCurrentUser() {
                return this.memberId === this.currentUserId || this.chapterAdminEditable;
            },
            isSectionVisible() {
                return this.myActivity && this.myActivity.length > 0;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .my-activity {
        margin-top: 5px;
        border-bottom: 1px solid $ypo-open-blue-gray;
        margin-bottom: 20px;
        padding-bottom: 10px;

        &__title {
            color: $ypo-gray-text;
            font-size: 14px;
            line-height: 20px;
            padding-left: 20px;
        }

        &__share {
            color: $ypo-dark-gray;
            font-size: 12px;
            line-height: 18px;
            padding-left: 20px;
            margin: 2px 0;
        }

        &__actions {
            color: $ypo-dark-gray;
            font-size: 10px;
            line-height: 14px;
            padding-left: 20px;
        }
    }

    h2 {
        color: $ypo_blue;
        font-family: "Raleway", sans-serif;
        font-size: 22px;
        font-weight: 500;
        margin-bottom: 20px;
        line-height: 26px;

        span {
            color: $ypo-cta;
            font-size: 14px;
            font-weight: bold;
            line-height: 19px;
            cursor: pointer;
        }

        i {
            color: $ypo-dark-background-gray;
            font-size: 14px;
            position: relative;
            left: 5px;
            margin-right: 30px;
            cursor: pointer;
        }

        em {
            color: $ypo-cta;
            font-family: "Noto Sans";
            font-size: 14px;
            line-height: 24px;
            font-style: normal;
            margin-left: 10px;
            cursor: pointer;
        }

        strong {
            color: $ypo_blue;
            font-size: 14px;
            font-weight: bold;
            line-height: 19px;
            text-transform: uppercase;
            position: relative;
            padding-left: 20px;

            i {
                color: $ypo_blue;
                font-size: 16px;
                font-weight: 600;
                margin-right: 10px;
                position: absolute;
                left: 0;
                top: 1px;
            }
        }

        .notFollowing {
            color: $ypo-cta;
            font-family: "Noto Sans";
            font-size: 14px;
            font-weight: bold;
            line-height: 19px;
            cursor: pointer;

            &.active {
                color: $ypo_blue;
            }
        }

        a {
            font-size: 12px;
            float: right;
        }

    }
</style>
